/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnpaidPaymentItem
 */
export interface UnpaidPaymentItem {
    /**
     * 支付记录ID
     * @type {number}
     * @memberof UnpaidPaymentItem
     */
    id?: number;
    /**
     * 会员名称
     * @type {string}
     * @memberof UnpaidPaymentItem
     */
    userName?: string;
    /**
     * 持卡人姓名
     * @type {string}
     * @memberof UnpaidPaymentItem
     */
    cardHolderName?: string;
    /**
     * 实际支付金额
     * @type {number}
     * @memberof UnpaidPaymentItem
     */
    actualPayAmount?: number;
    /**
     * 支付单编号
     * @type {string}
     * @memberof UnpaidPaymentItem
     */
    paymentCode?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof UnpaidPaymentItem
     */
    userCode?: string;
    /**
     * 申请日期
     * @type {string}
     * @memberof UnpaidPaymentItem
     */
    applyDate?: string;
    /**
     * 支付账单类型：1-账单类型，2-钱包类型
     * @type {number}
     * @memberof UnpaidPaymentItem
     */
    paymentBillType?: number;
}

/**
 * Check if a given object implements the UnpaidPaymentItem interface.
 */
export function instanceOfUnpaidPaymentItem(value: object): value is UnpaidPaymentItem {
    return true;
}

export function UnpaidPaymentItemFromJSON(json: any): UnpaidPaymentItem {
    return UnpaidPaymentItemFromJSONTyped(json, false);
}

export function UnpaidPaymentItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnpaidPaymentItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'cardHolderName': json['cardHolderName'] == null ? undefined : json['cardHolderName'],
        'actualPayAmount': json['actualPayAmount'] == null ? undefined : json['actualPayAmount'],
        'paymentCode': json['paymentCode'] == null ? undefined : json['paymentCode'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'applyDate': json['applyDate'] == null ? undefined : json['applyDate'],
        'paymentBillType': json['paymentBillType'] == null ? undefined : json['paymentBillType'],
    };
}

export function UnpaidPaymentItemToJSON(json: any): UnpaidPaymentItem {
    return UnpaidPaymentItemToJSONTyped(json, false);
}

export function UnpaidPaymentItemToJSONTyped(value?: UnpaidPaymentItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userName': value['userName'],
        'cardHolderName': value['cardHolderName'],
        'actualPayAmount': value['actualPayAmount'],
        'paymentCode': value['paymentCode'],
        'userCode': value['userCode'],
        'applyDate': value['applyDate'],
        'paymentBillType': value['paymentBillType'],
    };
}

